var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseSubmittedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.12313,
    cy: 6.01565,
    r: 4.75,
    transform: "rotate(178.985 5.12313 6.01565)",
    fill: "white",
    stroke: "#14BF86",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03155 1.00099C5.68809 0.991423 6.34008 1.11127 6.95031 1.35368C7.56053 1.59609 8.11703 1.95632 8.58804 2.4138C9.05905 2.87128 9.43533 3.41706 9.69542 4.01996C9.9555 4.62286 10.0943 5.27109 10.1038 5.92763L5.10438 6.00046L5.03155 1.00099Z",
    fill: "#14BF86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseSubmittedGreen);
export default __webpack_public_path__ + "static/media/ellipse-submitted-green.09d02d2118f8d9a3f977d1c76d97f73b.svg";
export { ForwardRef as ReactComponent };